/* ==========================================================
   ma-collection-header.js
   - Bottom sheet open / close for collection navigation
   Badges are plain <a> links using /collections/handle/tag
   URL format — no JS filtering needed.
   ========================================================== */

(function () {
  'use strict';

  // ── Active badge detection + scroll ──────────────────────

  function initBadges(container) {
    const wrap   = container.querySelector('.ma-col-header__badges-wrap');
    const badges = container.querySelectorAll('.ma-col-header__badge');
    if (!wrap || !badges.length) return;

    // Compare each badge's href path to the current pathname.
    // More reliable than Liquid's current_tags which can be empty in some contexts.
    const currentPath = window.location.pathname.replace(/\/$/, '');

    badges.forEach((badge) => {
      const href = (badge.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      badge.classList.toggle('ma-col-header__badge--active', href === currentPath);
    });

    // Scroll active badge into view, centered in the container
    const active = container.querySelector('.ma-col-header__badge--active');
    if (active) {
      wrap.scrollLeft = active.offsetLeft - wrap.offsetWidth / 2 + active.offsetWidth / 2;
    }

    // Mouse-drag scroll for desktop
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;

    wrap.addEventListener('mousedown', (e) => {
      isDragging   = true;
      startX       = e.pageX - wrap.offsetLeft;
      startScrollLeft = wrap.scrollLeft;
      wrap.style.cursor = 'grabbing';
      e.preventDefault();
    });

    wrap.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const x = e.pageX - wrap.offsetLeft;
      wrap.scrollLeft = startScrollLeft - (x - startX);
    });

    const stopDrag = () => {
      isDragging = false;
      wrap.style.cursor = '';
    };

    wrap.addEventListener('mouseup', stopDrag);
    wrap.addEventListener('mouseleave', stopDrag);
  }

  // ── Bottom sheet ──────────────────────────────────────────

  function initSheet(container) {
    const titleBtn = container.querySelector('.ma-col-header__title-btn');
    const sheet    = container.querySelector('.ma-col-sheet');
    const closeBtn = container.querySelector('.ma-col-sheet__close');

    if (!titleBtn || !sheet) return;

    // Open
    titleBtn.addEventListener('click', () => {
      sheet.showModal();
      titleBtn.setAttribute('aria-expanded', 'true');
    });

    // Close via button
    if (closeBtn) {
      closeBtn.addEventListener('click', () => sheet.close());
    }

    // Close via backdrop click (click lands directly on <dialog>)
    sheet.addEventListener('click', (e) => {
      if (e.target === sheet) sheet.close();
    });

    // Sync aria-expanded on close (ESC or backdrop)
    sheet.addEventListener('close', () => {
      titleBtn.setAttribute('aria-expanded', 'false');
    });
  }

  // ── Boot ─────────────────────────────────────────────────

  function boot() {
    const container = document.querySelector('.ma-col-header-section');
    if (!container) return;
    initBadges(container);
    initSheet(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
